export default "__VITE_ASSET__Bz9cYIch__"